import React, { useState } from 'react';

import { clearData, errorMessage, isUnauthorized } from '../../api';

export const CLEAR_WORD = 'BORRAR';

/**
 * The question before a clean-up (everyone, the purchases or the chat). Nothing else in the
 * panel is this hard to undo, and a second tap can be a slip of the finger: the word has to
 * be typed. It says what goes, runs the clean-up and tells whoever opened it how it went.
 */
const ClearConfirm = ({ adminKey, scope, warning, confirmLabel, onCleared, onCancel, onUnauthorized }) => {
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const ready = typed.trim().toUpperCase() === CLEAR_WORD;

  const run = async (e) => {
    e.preventDefault();
    if (!ready || busy) return;
    setBusy(true);
    setError(null);
    let result;
    try {
      result = await clearData(adminKey, scope);
    } catch (err) {
      setBusy(false);
      if (isUnauthorized(err)) onUnauthorized();
      else setError(errorMessage(err));
      return;
    }
    setBusy(false);
    if (result?.done) onCleared(result);
    else setError('Se borró una parte, pero quedó algo. Tocá de nuevo para terminar');
  };

  return (
    <form className='clear' onSubmit={run}>
      <p className='clear__warning'>{warning}</p>
      <div className='clear__row'>
        <input
          className='input clear__input'
          type='text'
          autoFocus
          autoComplete='off'
          autoCapitalize='characters'
          spellCheck={false}
          aria-label={`Escribí ${CLEAR_WORD} para confirmar`}
          placeholder={`Escribí ${CLEAR_WORD}`}
          value={typed}
          disabled={busy}
          onChange={(e) => setTyped(e.target.value)}
        />
        <button type='submit' className='btn-primary clear__go' disabled={!ready || busy}>
          {busy ? 'Borrando…' : confirmLabel}
        </button>
        <button type='button' className='panel__cancel' disabled={busy} onClick={onCancel}>
          Cancelar
        </button>
      </div>
      {error && <p className='form-error'>{error}</p>}
    </form>
  );
};

export default ClearConfirm;
